    import { uploadData } from 'aws-amplify/storage';
    import { v4 as uuidv4 } from 'uuid';

    /**
     * Uploads a recorded audio blob to S3
     * @param audioBlob - The audio Blob to upload
     * @param uploadPath - The folder path in S3 (e.g., "ticket-audios")
     * @returns S3 key string or undefined on failure
     */
    export const handleAudioUpload = async (audioBlob: Blob, uploadPath: string,name:string): Promise<string | undefined> => {
        const fileName = `${name}-${uuidv4()}.webm`;
        const key = `${uploadPath}/${fileName}`;

        try {
            const result = await uploadData({
                key: key,
                data: audioBlob,
                options: {
                    contentType: 'audio/webm',
                    accessLevel: 'guest', // or 'public'/'protected' based on your auth config
                },
            });

            const urlKey = await result.result;
            if (urlKey) {
                return urlKey.key;
            }

            throw new Error('Unexpected upload result format');
        } catch (error) {
            console.error('Audio Upload Error:', error);
            return undefined;
        }
    };
